import * as ClickStreamModule from './loaders/ClickStream';
import * as OneDMPModule from './loaders/OneDMP';
import * as YandexMetrikaModule from './loaders/YandexMetrika';

export default {
    Clickstream: ClickStreamModule,
    OneDMP: OneDMPModule,
    YandexMetrika: YandexMetrikaModule,
};

/**
 * Добавляет тип в значение enum, например REQUEST: BRANDING-REQUEST
 *
 * @param type
 * @param eventsEnum
 */
export function prepareEventsEnum<T>(type: string | null, eventsEnum: T): T {
    return Object.keys(eventsEnum).reduce((acc, next) => {
        acc[next] = type ? `${type}-${next}` : next;
        return acc;
    }, {} as { [key: string]: any }) as T;
}

export function rootObjName(
    literals: TemplateStringsArray,
    ...placeholders: any[]
) {
    let result = '';

    for (let i = 0; i < placeholders.length; i++) {
        result += literals[i];
        result += placeholders[i];
    }

    result += literals[literals.length - 1];

    return 'auth.wi-fi.ru/identification' + result;
}
